module.exports = __webpack_public_path__ + "img/pin.eb4a17af.svg";